import { GravyBinder } from "gravy-bind";
import reportValidity from 'report-validity';
import { AgencyPrincipalContactRequest } from "./models/contact/AgencyPrincipalContactRequest";
import { touchAllInputs } from "./utils/touch-all-inputs";
import { apiPost } from "./utils/api-post";

export class ContactAgencyPrincipal {
    public static cssClass = 'contact-agency-principal';
    private binder: GravyBinder;
    public data: AgencyPrincipalContactRequest;
    public loading: boolean = false;
    public submitted: boolean = false;

    constructor(private rootElement: HTMLFormElement) {
        this.data = new AgencyPrincipalContactRequest();
        this.rootElement.addEventListener('submit', this.onSubmit);
        this.binder = new GravyBinder(this, this.rootElement);
        const phoneInput = this.rootElement.querySelector('#PhoneCall') as HTMLInputElement;
        phoneInput?.addEventListener('input', (event => this.formatPhoneNumber(event)));
        const contactType = this.rootElement.querySelector('#contactMethod') as any;
        contactType?.addEventListener('change', () => this.onContactTypeChange());
        this.binder.updateOutwardBindings();
    }

    public onSubmit = async (event: Event): Promise<void> => {
        console.log(this.data);
        event.preventDefault();
        if (!this.loading && !this.submitted) {
            touchAllInputs(this.rootElement);
            reportValidity(this.rootElement); // using polyfill instead of form.reportValidity for IE support

            // runs default behaviour (submitting) in case of validation success
            if (this.rootElement.checkValidity())
                await this.sendSubmission();
        }
    }

    public sendSubmission = async (): Promise<void> => {
        this.loading = true;
        this.binder.updateOutwardBindings();
        try {
            Object.keys(this.data).forEach(key => {
                if (!this.data[key]) this.data[key] = null;
            }); // change empty strings to null to prevent validation issues
            await apiPost('/api/contact/agency-principal', this.data);
            this.submitted = true;
        } catch (e) {
            console.error(e);
        }
        this.loading = false;
        this.binder.updateOutwardBindings();
    }

    public formatPhoneNumber(event: Event): void {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/\D/g, '');

        if (value.length <= 3 && value.length > 0) {
            input.value = `(${value}`;
        } else if (value.length <= 6) {
            input.value = `(${value.substring(0, 3)}) ${value.substring(3)}`
        } else if(value.length > 6) {
            input.value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`;
        }
    }

    public onContactTypeChange(): void {
        const typeSelect = document.querySelector('#contactMethod') as any;
        const selectedValue = typeSelect.value;

        const emailField = this.rootElement.querySelector('#Email') as HTMLInputElement;
        const phoneField = this.rootElement.querySelector('#PhoneCall') as HTMLInputElement;
        if (selectedValue == 'Email') {    
            emailField.required = true;
            phoneField.required = false;
        } else {
            emailField.required = false;
            phoneField.required = true;
        }
    }
}